import { useNavigate } from "react-router-dom";

function useNavigator() {
  let navigate = useNavigate();

  const moveTo = (path: string) => {
    navigate(path);
  };
  return moveTo;
}

export default useNavigator;
